import { SectionTemplate } from "../../Templates/SectionTemplate";
import { SectionVersion } from "./SectionVersion";

export class Section {
	public static readonly $type: string = "Section";
	public readonly $type: string = Section.$type;

	public id?: number;
	public template!: SectionTemplate;
	public published?: SectionVersion;
	public draft?: SectionVersion;
	public superceded: SectionVersion[] = [];

	public constructor(sectionTemplate?: SectionTemplate, sectionVersion?: SectionVersion) {

		if (sectionTemplate !== undefined) {

			this.template = sectionTemplate;
		}

		if (sectionVersion !== undefined) {

			this.draft = sectionVersion;
		}
	}
}
